import Layout from "../Layout/Layout";
import { JsonLDData } from "react-safe-json-ld";

const DARKSKIES = "https://darkskies.earthboundmartian.com";
const LUNAMALIES = "https://lunamalies.earthboundmartian.com";

const upcoming = ["Music", "Renaissance fairs"];

const Activities = () => {
  const structuredData: JsonLDData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": "https://earthboundmartian.com/activities",
        name: "Activities & Destinations",
        description:
          "Overnight-capable outings for Landship travel — starting with van-accessible dark skies.",
        url: "https://earthboundmartian.com/activities",
        isPartOf: { "@id": "https://earthboundmartian.com/#organization" },
        mainEntity: {
          "@type": "ItemList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              item: {
                "@type": "WebSite",
                name: "Dark Skies",
                url: DARKSKIES,
                description:
                  "Find dark skies you can actually stay under. Vehicle-friendly sites, night lights, and new-moon windows.",
              },
            },
          ],
        },
      },
    ],
  };

  return (
    <Layout structuredData={structuredData}>
      <section className="max-w-7xl mx-auto px-6 py-20 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          Activities &amp; Destinations
        </p>
        <h1 className="text-5xl md:text-6xl font-bold text-alt-blk mt-3">
          Where do you want to go?
        </h1>
        <p className="text-2xl text-alt-blk/80 mt-4 max-w-3xl">
          What do you want to do?
        </p>
        <p className="text-lg text-zinc-600 mt-6 max-w-3xl leading-relaxed">
          The Landships are the how. This is the why — overnight-capable
          outings we actually care about. One live so far. More as we write
          them up, not as a directory of things we have not done.
        </p>

        <div className="mt-16 bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row">
          <a
            href={DARKSKIES}
            className="md:w-1/2 h-80 md:h-auto relative bg-alt-blk block"
          >
            <img
              src="/images/big_bend_hero.png"
              alt="Big Bend at dusk"
              className="w-full h-full object-cover"
            />
          </a>
          <div className="md:w-1/2 p-10 flex flex-col justify-center bg-alt-blk text-alt-wht">
            <p className="text-sun font-semibold tracking-wide uppercase text-sm">
              Stargazing
            </p>
            <h2 className="text-4xl font-bold text-ray tracking-tight mt-2">
              <a href={DARKSKIES} className="hover:text-sunset">
                Dark Skies
              </a>
            </h2>
            <p className="mt-6 text-alt-wht/85 leading-relaxed">
              A map of places you can actually sleep under a dark sky — Texas,
              the Southwest, and the West. Night lights, new-moon windows, and
              notes on whether a van will fit.
            </p>
            <a
              href={DARKSKIES}
              className="mt-8 inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold text-center transition-all w-fit"
            >
              Open the map
            </a>
            <p className="mt-6 text-sm text-alt-wht/70">
              Lunar catalog:{" "}
              <a href={LUNAMALIES} className="text-ray hover:text-sunset">
                Lunamalies
              </a>
            </p>
          </div>
        </div>

        <div className="mt-16 max-w-3xl">
          <h2 className="text-2xl font-bold text-alt-blk mb-3">On the list</h2>
          <p className="text-zinc-600 leading-relaxed mb-4">
            We'll add these when we have somewhere worth sending you.
          </p>
          <ul className="flex flex-wrap gap-2">
            {upcoming.map((label) => (
              <li
                key={label}
                className="text-sm px-4 py-1.5 rounded-full border border-alt-blk/20 text-alt-blk/70"
              >
                {label}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-16 max-w-3xl border-t border-alt-blk/10 pt-10">
          <h2 className="text-2xl font-bold text-alt-blk mb-3">
            Not a destination
          </h2>
          <p className="text-zinc-600 leading-relaxed">
            <a
              href={LUNAMALIES}
              className="text-turquoise hover:text-mars font-semibold"
            >
              Lunamalies
            </a>{" "}
            is a catalog of reported lunar anomalies — old observations, a moon
            map, citations. We keep it because we like it. You cannot camp
            there… yet.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Activities;
